import { Klass , u_ } from "@pressmedia/webappbase";
import "@pressmedia/tyrellmodule";
import auth from "./auth";
import item from "./item";


Klass.create("WallaceModule").extends_("TyrellModule", {
	...auth,
	...item,
	
	/**
	 * [コンストラクタ]
	 * @returns this
	 */
	_initialize() {
		Klass("WallaceModule").parent._initialize.apply(this, arguments);
		if( !u_.isFunction(this.errorCallbacks.LOGIN) ) {
			this.errorCallbacks.LOGIN = this.loginErrorCallback;
		}
		return this;
	},
	
	/**
	 * [override] dataKeyのセット
	 * dataKeyの変更時にpagerのベースURLも更新する
	 * @returns this
	 */
	setDataKey() {
		Klass("WallaceModule").parent.setDataKey.apply(this, arguments);
		
		if(this.vuw) {
			const pager = this.vuw.get("pager");
			!!pager && (pager.baseUrl = this.app.URL);
		}
		
		return this;
	},
	
	/**
	 * [override] ajaxリクエスト送信
	 * アクセストークンの付与、およびログインフォームの情報の取得
	 * @param {String} method
	 * @param {Object} [ajaxSetting]
	 * @param {Function} [callback]
	 * @returns Promise
	 */
	_sendRequest(method, ajaxSetting, callback) {
		u_.isObject(ajaxSetting) || (ajaxSetting = {});
		
		if(!this.getDataKey() && ajaxSetting.endPoint === "config") {
			// システム設定の取得時に、ログインフォームの情報も取得する
			u_.isObject(ajaxSetting.data) || (ajaxSetting.data = {});
			ajaxSetting.data.fields = "auth";
			
		}
		
		const nextToken = this.app.storage.get("nextToken");
		if(nextToken) {
			// アクセストークンを持っている場合は送信
			const scheme = !this._scheme ? "" : `${this._scheme} `;
			u_.isObject(ajaxSetting.headers) || (ajaxSetting.headers = {});
			ajaxSetting.headers[this._authHeader] = scheme + nextToken;
		}
		
		return Klass("WallaceModule").parent._sendRequest.call(
			this,
			method,
			ajaxSetting,
			(err, res, xhr, textStatus) => {
				if( u_.isObject(res) && res.nextToken ) {
					this.app.storage.set("nextToken", res.nextToken);
				}
				return u_.isFunction(callback) && callback(err, res, xhr, textStatus);
			}
		);
	},
});
